<template>
  <div class="page" :class="[mediaClass.screenType, mediaClass.portOrLand, {tinyLand: mediaClass.tinyLand}]">
    <div class="mainContent">
      <router-view v-slot="{ Component, route }">
        <keep-alive>
          <component :key="route.name" :is="Component" />
        </keep-alive>
      </router-view>
    </div>
    <TopHeader></TopHeader>
    <Footer></Footer>
    <Popup></Popup>
  </div>
</template>

<script setup lang="ts">
import "@/assets/scss/index.scss";
import TopHeader from '@/components/common/Header.vue'
import mediaClass from '@/hooks/queryMediaClass.ts'
import Footer from '@/components/common/Footer.vue'
import Popup from '@/components/common/Popup.vue'
</script>
